String.prototype.isEmpty = function () {
	return this == null || this == "";
};

String.prototype.isNotEmpty = function () {
	return this != null && this != "";
};
